import axios from 'axios';
import {
  RUNNING_TYPE,
  RUNNING_TYPE_MASTER,
  RUNNING_TYPE_DEVELOP,
  RUNNING_TYPE_LOCAL,
  API_KEY,
  API_KEY_RC_TEST,
  API_URL,
  API_DEV_URL,
  API_LOCAL_URL,
  FILE_DELETE_API,
} from '../util/Const';

/**
 * ファイル削除APIリクエストIF
 */
export type SendRequestDto = {
  id: any;
  fileName: any;
};

// ファイル削除API
export const PostFileDelete = async (dto: SendRequestDto) => {
  let url: string;
  let apiKey: string;
  switch (RUNNING_TYPE) {
    case RUNNING_TYPE_MASTER:
      url = API_URL + FILE_DELETE_API;
      apiKey = API_KEY;
      break;
    case RUNNING_TYPE_DEVELOP:
      url = API_DEV_URL + FILE_DELETE_API;
      apiKey = API_KEY_RC_TEST;
      break;
    case RUNNING_TYPE_LOCAL + FILE_DELETE_API:
      url = API_LOCAL_URL;
      apiKey = API_KEY_RC_TEST;
      break;
    default:
      url = '';
      apiKey = '';
      break;
  }

  if (
    RUNNING_TYPE === RUNNING_TYPE_MASTER ||
    RUNNING_TYPE === RUNNING_TYPE_DEVELOP ||
    RUNNING_TYPE === RUNNING_TYPE_LOCAL
  ) {
    const res = await axios
      .post(url, JSON.stringify(dto), {
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': apiKey,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
    return res;
  }
  const res = await axios
    .get(url)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
  console.info(JSON.stringify(dto));
  return res;
};

export default PostFileDelete;
